import { palette } from "@kashmere/core";

// #291 — the Atén colour names survive (their call sites did not change); every
// VALUE is a reference to a canonical token in packages/core/src/design/tokens.ts
// (ADR-0009). This module declares no colour of its own — canon.guard.test.ts
// scans it. The road-trip palette was light-first (warm sand, espresso text);
// the canon is dark-first, so the neutrals invert: page/surface tokens where a
// warm background was, text tokens where a warm ink was.
export const colors = {
  // Product accent — Atén is teal in the canon too.
  teal:  { DEFAULT: palette.teal.base, light: palette.teal.lit, dark: palette.teal.ink },
  // "Coral" was the danger/thermal accent → the status red.
  coral: { DEFAULT: palette.pink.lit, light: palette.pink.muted, dark: palette.pink.base },
  gold:  { DEFAULT: palette.gold.base, light: palette.gold.bright, dark: palette.gold.base },
  plum:  { DEFAULT: palette.plum, light: palette.plum, dark: palette.plum },

  // Warm neutrals, inverted for a dark-first surface.
  espresso:  palette.text.cream,      // was the darkest ink → the brightest text
  stone:     palette.text.secondary,
  sandstone: palette.text.dim,
  cashmere:  palette.border.mid,      // was the light rule/border
  warmSand:  palette.bg.page,         // was the page
  cream:     palette.bg.panel,        // was the raised surface
  white:     palette.text.cream,      // as an ink (on accents, on photos)
  surface:   palette.bg.panel,        // where a white CARD was

  // Dark dashboard — already dark; now the same page/panel the rest of the estate uses.
  darkBase:  palette.bg.page,
  darkCard:  palette.bg.panel,
  darkPlum:  palette.bg.surface,
  darkTeal:  palette.bg.surface,
  darkCoral: palette.bg.surface,
  darkGold:  palette.bg.surface,
};

export const productColors = {
  aten:  colors.teal.DEFAULT,
  pulse: colors.coral.dark,
  silk:  colors.gold.DEFAULT,
  esqe:  colors.plum.DEFAULT,
};
